import React, { forwardRef } from 'react';
import styled from "styled-components";
import classnames from "classnames";
import IBuildrProps from 'src/utilities/IBuildrProps';
import AdobeTarget from '../AdobeTarget';
import linkArrow from "./../../icons/link-arrow.svg";
import SearchProvider from '../Search/SearchProvider';
import SearchForm from '../Search/SearchForm';
import SearchResults from '../Search/SearchResults';
import { getTranslation } from '../Search/translations';
import useLanguage from '../../utilities/useLanguage';

interface IHeroBarProps extends IBuildrProps {
    title: string;
    children: any;
    adobeWait: string;
    focus?: boolean;
}

const HeroBar = forwardRef((props: IHeroBarProps, ref: any) => {

    const { cmsId, editorClassObj, className, title, children } = props;
    const { lang } = useLanguage();
    return (
        <SearchProvider>
            <div data-id={cmsId} ref={ref} className={editorClassObj}>
                <AdobeTarget id="wcwhyw-target" adobeWait={props.adobeWait} className={classnames(className, 'px-4 py-5 pt-lg-0 row flex-column')}>
                    <div id="wcwhyw-above-target" className="hero"></div>
                    <div className="hero-bar bg-primary p-4 text-center w-100">
                        <div className="bar-title text-xxl-left">{title}</div>
                        <div className="d-flex flex-column flex-xxl-row">
                            <nav className="d-flex mr-xxl-4 pt-xxl-2 mt-4 mb-2 my-xxl-0 flex-grow-1 align-items-center">
                                <div className="bar-nav d-flex justify-content-center justify-content-xxl-between flex-grow-1 flex-column flex-md-row flex-nowrap flex-md-wrap flex-xxl-nowrap">
                                    {children}
                                </div>
                            </nav>
                            <div className="bar-search-container">
                                <SearchForm inputPlaceholder={getTranslation(lang).search} focus={props.focus} containerClass="rounded-pill search-box" inputClass="text-white bg-transparent" />
                            </div>
                        </div>
                    </div>
                    <SearchResults />
                </AdobeTarget>
            </div>
        </SearchProvider>
    );
});

export default styled(HeroBar)`

    z-index: 1;

    .search-box {
        background: rgba(217, 217, 217, 0.1);
        box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 4px 0px;
        backdrop-filter: blur(10px);
    }

    .search-results-container {
        @media (min-width: 1440px) {
            margin-left: auto;
            max-width: 768px;
        }
    }

    .hero-bar {
        border-radius: 4px;
        min-height: 126px;
        @media (max-width:991px) {
            text-align: center;
        }
    }

    .bar-title {
        font-family: "National2";
        font-size: 0.889rem;
        line-height: 1.333rem;
        font-weight: 400;
        color: #fff;
    }

    .bar-nav {
        @media (min-width: 768px) and (max-width: 1439px) {
            margin-left: 75px;
            margin-right: 75px;
        }
    }

    .bar-search-container {
        height: 48px;
        margin: 0;
        @media (min-width: 768px) and (max-width: 1439px) {
            margin-left: 75px;
            margin-right: 75px;
        }
        @media (min-width: 1440px) {
            margin-left: auto;
            width: 296px;
        }
    }

    .link-item {
        font-family: "National2 Narrow";
        font-size: 0.889rem;
        line-height: 1.55556rem;
        font-weight: 700;
        color: white;
        text-decoration: none;
        display: inline-block;
        cursor: pointer;

        &::after {
            content: '';
            width: 15px;
            height: 14px;
            display: inline-block;
            background-image: url(${linkArrow});
            margin-left: 3px;
            margin-bottom: -2px;
            transform: translateX(0);
            transition: transform .15s ease;
        }

        &:hover {
            &::after {
                transform: translateX(5px);
            }
        }
    }
`;